import Axios from 'axios';

import {
	WORKER_STATS_LOADING,
	WORKER_STATS_HOURLY_GET,
	WORKER_STATS_HOURLY_ERROR,
	WORKER_STATS_DAILY_GET,
	WORKER_STATS_DAILY_ERROR,
	WORKER_STATS_DAYS_GET,
	WORKER_STATS_DAYS_ERROR,
	WORKER_STATS_CURRENT_GET,
	WORKER_STATS_CURRENT_ERROR,
	WORKER_STATS_PERFORMANCE_GET,
	WORKER_STATS_PERFORMANCE_ERROR,
	WORKER_STATS_SUMMARY_GET,
	WORKER_STATS_SUMMARY_ERROR,
	WORKER_STATS_TYPE_GET,
	WORKER_STATS_TYPE_ERROR,
	WORKER_STATS_PEAK_GET,
	WORKER_STATS_PEAK_ERROR,
	WORKER_STATS_COMPARISON_GET,
	WORKER_STATS_COMPARISON_ERROR,
	WORKER_STATS_ANOMALIES_GET,
	WORKER_STATS_ANOMALIES_ERROR
} from './types';

export const get_worker_stats_hourly = (instance_id, hours = 24) => dispatch => {
	dispatch({ type: WORKER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/workers/${instance_id}/stats/hourly?hours=${hours}`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: WORKER_STATS_HOURLY_GET, payload: res.data });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: WORKER_STATS_HOURLY_ERROR, payload: { type: 'worker_stats_hourly', msg: err.message } });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	})
}

export const get_worker_stats_daily = (instance_id, start, end) => dispatch => {
	dispatch({ type: WORKER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/workers/${instance_id}/stats/daily?start=${start}&end=${end}`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: WORKER_STATS_DAILY_GET, payload: res.data });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: WORKER_STATS_DAILY_ERROR, payload: { type: 'worker_stats_daily', msg: err.message } });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	})
}

export const get_worker_stats_days = (instance_id, days = 7) => dispatch => {
	dispatch({ type: WORKER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/workers/${instance_id}/stats/days?days=${days}`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: WORKER_STATS_DAYS_GET, payload: res.data });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: WORKER_STATS_DAYS_ERROR, payload: { type: 'worker_stats_days', msg: err.message } });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	})
}

export const get_worker_stats_current = (instance_id, minutes = 5) => dispatch => {
	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/workers/${instance_id}/stats/current?minutes=${minutes}`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: WORKER_STATS_CURRENT_GET, payload: res.data });
	}).catch((err) => {
		dispatch({ type: WORKER_STATS_CURRENT_ERROR, payload: { type: 'worker_stats_current', msg: err.message } });
	})
}

export const get_worker_stats_performance = (instance_id) => dispatch => {
	dispatch({ type: WORKER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/workers/${instance_id}/stats/performance`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: WORKER_STATS_PERFORMANCE_GET, payload: res.data });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: WORKER_STATS_PERFORMANCE_ERROR, payload: { type: 'worker_stats_performance', msg: err.message } });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	})
}

export const get_worker_stats_summary = (instance_id) => dispatch => {
	dispatch({ type: WORKER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/workers/${instance_id}/stats/summary`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: WORKER_STATS_SUMMARY_GET, payload: res.data });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: WORKER_STATS_SUMMARY_ERROR, payload: { type: 'worker_stats_summary', msg: err.message } });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	})
}

export const get_worker_stats_type = (instance_id, type, hours = 24) => dispatch => {
	dispatch({ type: WORKER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/workers/${instance_id}/stats/type?type=${type}&hours=${hours}`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: WORKER_STATS_TYPE_GET, payload: res.data });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: WORKER_STATS_TYPE_ERROR, payload: { type: 'worker_stats_type', msg: err.message } });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	})
}

export const get_workers_stats_peak = (days = 7) => dispatch => {
	dispatch({ type: WORKER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/workers/stats/peak?days=${days}`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: WORKER_STATS_PEAK_GET, payload: res.data });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: WORKER_STATS_PEAK_ERROR, payload: { type: 'worker_stats_peak', msg: err.message } });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	})
}

export const get_workers_stats_comparison = (workerIds, hours = 24) => dispatch => {
	dispatch({ type: WORKER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/workers/stats/comparison?workers=${workerIds}&hours=${hours}`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: WORKER_STATS_COMPARISON_GET, payload: res.data });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: WORKER_STATS_COMPARISON_ERROR, payload: { type: 'worker_stats_comparison', msg: err.message } });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	})
}

export const get_worker_stats_anomalies = (instance_id) => dispatch => {
	dispatch({ type: WORKER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/workers/${instance_id}/stats/anomalies`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: WORKER_STATS_ANOMALIES_GET, payload: res.data });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: WORKER_STATS_ANOMALIES_ERROR, payload: { type: 'worker_stats_anomalies', msg: err.message } });
		dispatch({ type: WORKER_STATS_LOADING, payload: false });
	})
}
